import { TextField } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from './RoadCondition.module.scss';
import './EditorsModal.scss';

const SubmitAlertModal = (props) => {

    return (
        <>
            <Modal
                show={props.show}
                onHide={props.onHide}
                backdrop="static"
                keyboard={false}
                centered
                dialogClassName="editorsModal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{props.modalMessage}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ul>
                    {props.modalBody.map(item => (
                        <li key={item}>
                          {item}
                        </li>
                    ))}
                    </ul>
                </Modal.Body>
                <Modal.Footer>
                <Button className={styles.submitButton} variant="contained" color="primary" onClick={props.onSave}> Submit</Button>
                    
            <div style={{ width:"2px" }}></div><Button className={styles.cancelButton} variant="outlined" color="secondary" onClick={props.onDiscard}>
                         Cancel
            </Button>
                    
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default SubmitAlertModal;